import React from 'react';
import { Stack, Typography } from '@mui/material';
import {
  PhoneOutlined as PhoneIcon,
  EmailOutlined as EmailIcon,
  LocationOnOutlined as LocationIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { formatPhone, formatRelative } from '../../../utils/formatters';

const ClientContactInfo = ({ phone, email, city, state, lastMessageAt }) => {
  const { t, i18n } = useTranslation();
  const location = [city, state].filter(Boolean).join(', ');
  const relativeTime = formatRelative(lastMessageAt, i18n.language, { empty: null });

  return (
    <Stack spacing={1} sx={{ mb: 1.5 }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <PhoneIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
        <Typography variant="body2" color="text.secondary">
          {phone ? formatPhone(phone) : t('notAvailable')}
        </Typography>
      </Stack>

      {email && (
        <Stack direction="row" spacing={1} alignItems="center">
          <EmailIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            {email}
          </Typography>
        </Stack>
      )}

      {location && (
        <Stack direction="row" spacing={1} alignItems="center">
          <LocationIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            {location}
          </Typography>
        </Stack>
      )}

      {relativeTime && (
        <Typography variant="caption" color="text.secondary">
          {t('clients.lastMessage')}: {relativeTime}
        </Typography>
      )}
    </Stack>
  );
};

export default ClientContactInfo;
